import { defineEvent, defineStore } from "../../nexus/defines";
import type { AsyncNamespace } from "../../nexus/namespace/namespace.types";
import type { NavigationParameters, ParameterRecord } from "../params/params.types";
import { stateParams } from "../state/state";
import type { NavigationState, StateManaged, StateRecord } from "../state/state.types";
import { NAV_META, NAV_SCOPES, type KeyFilter } from "../lib/utils";
import type {
  NavigationScopeAsync,
  NavigationScopeOptions,
  NavigationScopeState,
} from "./scope.types";
import { baseLocation } from "../lib/location";
import { win } from "../../../common/namespaces";

/**
 *
 *
 *
 *
 *
 *
 */
export const getScopedState = (scope: string, state: StateManaged): NavigationState<StateRecord> =>
  stateParams(state[NAV_SCOPES][scope]);

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const setScope = (scope: string, state: StateManaged, value: StateRecord): StateManaged => {
  state[NAV_META][scope] = win.performance.now();
  state[NAV_SCOPES][scope] = value;
  return state;
};

/**
 *
 *
 *
 */
export const ensureEntry = <T>(map: Map<KeyFilter, Set<T>>, key: KeyFilter): Set<T> => {
  if (!map.has(key)) map.set(key, new Set());
  return map.get(key)!;
};

/**
 *
 *
 *
 *
 *
 *
 */
export const ensureRegExpEntry = <T>(
  map: Map<RegExp, Set<T>>,
  pattern: RegExp | undefined,
): Set<T> | undefined => {
  if (!pattern) return;
  const key = new RegExp(pattern);
  if (Array.from(map.keys()).every((k) => k.toString() !== key.toString())) map.set(key, new Set());
  return map.get(key)!;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const initializeNamespaceWithCurrentNavigation = (
  namespace: AsyncNamespace<NavigationScopeAsync>,
  state: NavigationState<StateRecord>,
  hash: NavigationParameters<ParameterRecord>,
  search: NavigationParameters<ParameterRecord>,
): void => {
  /*                                                         */
  if (!namespace.isReady) {
    namespace.assignNamespace({
      current: defineStore<NavigationScopeState<NavigationScopeOptions>>({
        url: new URL(baseLocation.href),
        state,
        hash,
        search,
        type: "push",
      }),
      currentHash: defineStore(hash),
      currentSearch: defineStore(search),
      currentState: defineStore(state),
      onNavigate: defineEvent(),
    });
  }
};
